import { Button } from '@chakra-ui/button';
import { Box, Center, Flex, Heading, Stack, Text } from '@chakra-ui/layout';
import { motion } from 'framer-motion';
import React from 'react';
import { ArrowDown } from 'react-feather';

interface RegisterConsentProps {
  hasConfirmed: (b: boolean) => void;
  hasDeclined: () => void;
}

export const RegisterConsent: React.FC<RegisterConsentProps> = ({
  hasConfirmed,
  hasDeclined,
}) => (
  <Box>
    <Center flexDirection="column" mb={6}>
      <Text mb={3} fontWeight="bold" textAlign="center">
        Um ein Konto für dich anlegen zu können, benötigen wir die nachstehende
        Einwilligung.
        <br />
        Bitte scrolle bis zum Ende, um zum nächsten Schritt zu gelangen!
      </Text>
      <motion.div
        animate={{ y: ['6px', '0px'] }}
        transition={{ duration: 0.5, yoyo: Infinity }}
      >
        <ArrowDown />
      </motion.div>
    </Center>
    <Box borderRadius="md" bg="gray.100" mb={6} overflow="hidden">
      <Stack maxHeight="50vh" overflowY="auto" p={3}>
        <Heading size="h4">
          Einwilligung in Übermittlung von personenbezogenen Daten in
          Drittstaaten
        </Heading>
        <Text fontSize="sm">
          Die Anwendung basiert auf der Firebase-Plattform der Google LLC, 1600
          Amphitheatre Parkway, Mountain View, California 94043. Zudem werden
          beim Streaming der Kurse Dienste der 8x8, INC., 2125 O'Nel Drive, San
          Jose, California 95131 verwendet. Die von Ihnen für die
          Inanspruchnahme der Anwendung anzugebenden Daten (Vor- und Nachname,
          Mitgliedschaftsnummer) sowie Ihre IP-Adresse müssten daher in die USA
          übermittelt werden. Die Übermittlung personenbezogener Daten in ein
          Drittland, um dass es sich bei den USA handelt, ist nur zulässig, wenn
          die in Art. 44 ff. DSGVO niedergelegten Bedingungen einhält. <br />
          Für die USA besteht aktuell kein Angemessenheitsbeschluss der
          EU-Kommission im Sinne des Art. 45 Abs. 1, 3 DSGVO. Das heißt, dass
          die EU-Kommission bislang nicht positiv festgestellt hat, dass das
          landesspezifische Datenschutzniveau von den USA dem der EU aufgrund
          der DSGVO entspricht. Es bestehen auch keine geeigneten Garantien Art.
          46 Abs. 2, 3 DSGVO. Nach Art. 49 Abs. 1 lit. a DSGVO ist die
          beabsichtigte Übermittlung jedoch zulässig, wenn Sie in die
          vorgeschlagene Datenübermittlung ausdrücklich einwilligen, nachdem Sie
          über die bestehenden möglichen Risiken derartiger Datenübermittlungen
          ohne Vorliegen eines Angemessenheitsbeschlusses und ohne geeignete
          Garantien unterrichtet wurden. Mögliche Risiken sind insbesondere,
          dass Ihre personenbezogenen Daten über den eigentlichen Zweck hinaus
          durch die Google LLC und die 8x8, INC. an andere Dritte weitergegeben
          werden. Es besteht zudem möglicherweise eine höhere
          Wahrscheinlichkeit, dass es zu einer nicht korrekten Datenverarbeitung
          kommen kann, da die technischen und organisatorischen Maßnahmen dieser
          Unternehmen zum Schutze personenbezogener Daten quantitativ und
          qualitativ nicht vollumfänglich den Anforderungen der DSGVO
          entsprechen.
        </Text>
        <Heading size="h5">
          Einwilligung und Belehrung über Widerrufsrecht
        </Heading>
        <Text fontSize="sm" mb={6}>
          Ich bin mit der Übermittlung meiner personenbezogenen Daten zum Zwecke
          der Inbetriebnahme der Anwendung an unsere technischen Dienstleister
          Google LLC und die 8x8, INC. einverstanden. Die Einwilligung kann ich
          jederzeit widerrufen. Durch einen Widerruf wird die Rechtmäßigkeit der
          aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung
          nicht berührt.
        </Text>
        <Flex pt={6} justify="flex-end">
          <Button colorScheme="red" variant="outline" onClick={hasDeclined}>
            Nicht einverstanden
          </Button>
          <Button ml={3} colorScheme="green" onClick={() => hasConfirmed(true)}>
            Einverstanden
          </Button>
        </Flex>
      </Stack>
    </Box>
  </Box>
);
